import { Overlay } from '../../components/overlay/overlay';

class MaterialZoomshot {
    constructor ($materialZoomshot) {
        this.$materialZoomshot = $materialZoomshot;
        this.$parent = document.querySelector('.material');
        this.$overlay = this.$parent?.querySelector('[data-overlay="root"]');
        this.materialID = this.$materialZoomshot.getAttribute('data-id');
        this.zoomShotOnInit = this.$materialZoomshot.getAttribute('data-open-zoomshot');

        const WINDOW_LOCATION = window.location;
        const BASE_URL = WINDOW_LOCATION.protocol + '//' + WINDOW_LOCATION.host + '/' + WINDOW_LOCATION.pathname.split('/')[1];
        this.requestUrl = `${BASE_URL}/material-color/${this.materialID}`;
    }

    initialize () {
        if (this.$overlay) {
            this.overlay = new Overlay(this.$overlay);
            this.overlay.initialize();

            this.$overlayImage = this.overlay.$overlay.querySelectorAll('.material-color__item')[0];
            this.$overlayBreadcrumb = this.overlay.$overlay.querySelectorAll('.material-color__breadcrumb span')[0];

            this.bindEvents();
        }
    }

    bindEvents () {
        const initOverlay = () => {
            this.overlay.showOverlay();
            this.getMaterialContent();
        };

        if (this.$materialZoomshot) {
            this.$materialZoomshot.addEventListener('click', () => {
                initOverlay();
            });

            this.overlay.$close.addEventListener('click', () => {
                this.removeMaterialContentFromOverlay();
            });

            document.addEventListener('keyup', (e) => {
                if (e.key === 'Escape' && this.$overlay.classList.contains('overlay--visible')) {
                    this.overlay.hideOverlay();
                    this.removeMaterialContentFromOverlay();
                }
            });

            if (this.zoomShotOnInit) {
                initOverlay();
            }
        }
    }

    getMaterialContent () {
        fetch(this.requestUrl).then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        }).then((data) => {
            this.setMaterialContentToOverlay(data);
        }).catch((err) => {
            console.warn('Something went wrong while getting Material Content: ', err);
        });
    }

    removeMaterialContentFromOverlay () {
        this.$overlayImage.innerHTML = '';
        this.$overlayBreadcrumb.innerHTML = '';
    }

    setMaterialContentToOverlay (data) {
        this.$overlayBreadcrumb.innerHTML = data.name;
        this.$overlayImage.innerHTML = data.zoomShot;
    }
}

export { MaterialZoomshot };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-material-zoomshot="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new MaterialZoomshot($root);
            $rootAPI.initialize();
        });
    }
});
